import styled from 'styled-components'
import { bgImage, heading1, label } from '../../resources/theme/css'
import { bp, font } from 'lib/core/resources/helpers/styled'
import { BP } from 'resources/constants'

export const PublicLayout = styled.div`
  padding: 100px 20px;
  min-height: calc(100vh - 310px);
  ${bgImage}
  ${bp('sm')`
    padding: 40px 20px 60px;
    min-height: calc(100vh - 160px);
    height: auto;
  `}

  > div {
    max-width: 480px;
    margin: 0 auto 50px;
    background: ${props => props.theme.palette.general.lightOpacity};
    padding: 32px;
    border-radius: 10px;
  }

  &.general-content {
    padding-top: 45px;

    > div {
      ${props => props.theme.css.container};
      border-radius: 0 0 10px 10px;
      padding: 0;

      form {
        padding: 20px 30px;
        ${bp('sm')`
          padding: 20px 15px;
        `}

        label {
          ${label}
        }
      }
    }

    &.product-selector {
      > div {
        padding: 0 !important;
        width: auto;
        ${bp('lg')`
          width: 90%;
        `}

        ${bp('sm')`
          width: 100%;
        `}

        @media (min-width: ${BP.lg.max}) {
          width: ${BP.sm.min};
        }
      }
    }
  }

  &.survey-results {
    &::before {
      background: rgba(52, 93, 127, 0.8);
    }

    > div {
      background: transparent;
      max-width: unset;

      &:first-child {
        margin-bottom: 0;
        padding: 0;
      }

      > div {
        margin: 10px auto 20px;

        &:first-child {
          max-width: 850px;
        }

        &:last-child {
          max-width: 900px;
        }
      }
    }
  }

  h2 {
    ${heading1}
    text-align: center;
  }

  form {
    .inline {
      ${bp('sm')`
        order: -1;
      `}
    }
  }

  .help {
    display: flex;
    align-items: center;
    justify-content: center;
    font: ${font('default', 'bold', '16px/1')};
    margin-top: 30px;
    color: ${props => props.theme.palette.primary.alphaDark};
    cursor: pointer;

    > img {
      width: 30px;
      height: 30px;
      margin-left: 5px;
    }
  }
`
